import '../components/styles/main.css'
import Title from '../components/core/Title'
import Text from './core/Text'
import WhiteBorderBtn from './UI/WhiteBorderBtn'
import mainImg from '../assets/images/main-img.png'

export default function Main() {
  return (
    <div id='home' className='main'>
      <div className="container">
        <div className='main__colum info'>
            <div className='main__title'>
                <Title>
                  <span>You've done the work</span>
                  <span>let us take care of the rest</span>
                </Title>
            </div>
            <div className='main__title-mobile'>
                <Title>
                  You've done the work let us take care of the rest
                </Title>
            </div>
            <div className='main__text'>
                <Text
                text={`Resume Raise is an AI driven service that 
                simplifies all things related to your job search. 
                Ditch the frustration and start seeing results.`}
                />
            </div>
            <div className='main__buttons'>
                <a href='/' className='main__white-btn'>
                    <span className='lowercase'>Try our </span>
                    <span className='uppercase'>RESUME BUILDER</span>
                </a>
                <WhiteBorderBtn width='118' text='Features'/>
            </div>
        </div>
        <div className="main__colum img">
            <img src={mainImg} alt={'main-img'}/>
        </div>
      </div>
    </div>
  )
}
